import React, { CSSProperties, useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { IOrgStageCoordsGetterOutput } from '../../functions/getOrgStages-1'
import { colors, constants } from '../../../../Constants'
import RootStoreContext from '../../../../storage/RootStore'
import './Views.scss'
import { When } from 'react-if'
import { getProblemInfo, getProblemsForStage } from '../../../../dict/PROBLEMS'

/// functions
/// types
/// components

interface ProblemsProps extends IOrgStageCoordsGetterOutput { }

export const Problems: React.FC<ProblemsProps> = observer(({
    orgStagesCoords, arrayOrgNodes, connectionDotsCoords, arrayStages
}) => {

    const {selection, dimensions} = useContext(RootStoreContext)
    const { BLOCK } = constants

    return (<When condition={!!arrayStages}>
        {arrayStages && arrayStages.filter((stageID, i) => i > 0).map((stageID, stageIndex) => {

            const x = BLOCK.WIDTH * (stageIndex + 1);
            const y = 0;

            return (<g x={x} y={y}>


                {/* <D3Rect rectColor='lightblue' x={x} y={0} width={BLOCK_WIDTH} height={BLOCK_HEIGHT} /> */}
                <foreignObject x={x} y={y} width={BLOCK.WIDTH} height={dimensions.HEIGHT_MATRIX_CONTAINER}>
                    <div style={{ width: BLOCK.WIDTH, height: dimensions.HEIGHT_MATRIX_CONTAINER }}>

                        {getProblemsForStage(stageID).map(problemID => {

                            const { problemName} = getProblemInfo(problemID)

                            const isSelected = problemID === selection.problem || (!selection.problem && selection.stage === stageID)

                            const styleSelected: CSSProperties = {
                                background : constants.BLOCK.COLOR_SELECTED,
                            }

                            const onClick = (e) => {
                                selection.setStage(stageID)
                                selection.setProblem(problemID)
                                e.preventDefault()
                                e.stopPropagation()
                            }

                            return (
                                <div className='svg-div' onClick={onClick} style={{textAlign: 'left',...(isSelected ? styleSelected : {})}}>
                                    {problemName}
                                </div>
                            )
                        })}
                    </div>
                </foreignObject>

            </g>)
        })}
    </When>)
})
